import { useEffect } from 'react';

/** Titel des Browser-Tabs in der Betreiberoberfläche. Beim Verlassen kehrt der Titel des Backoffice zurück. */
export function useOperatorTitle(): void {
  useEffect(() => {
    const before = document.title;
    document.title = 'Wirkia Betreiber';
    return () => {
      document.title = before;
    };
  }, []);
}
